import React from "react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

function FieldLabel({ children }) {
  return (
    <label className="block text-xs uppercase tracking-widest text-[#8B5E34] mb-1.5" style={LORA}>
      {children}
    </label>
  );
}

export function EditorGeneralFields({ result, setField }) {
  return (
    <div
      className="space-y-4 p-4 border border-[#DCD4C6] bg-[#FAF7F3]"
      style={{ borderRadius: "2px" }}
    >
      <p className="text-xs uppercase tracking-widest text-[#8B5E34]" style={LORA}>
        Vue générale
      </p>
      <div>
        <FieldLabel>Résumé du voyage</FieldLabel>
        <textarea
          className="w-full border border-[#DCD4C6] bg-white px-3 py-2 text-sm text-[#2B2623] resize-none focus:outline-none focus:border-[#C17F59] transition-colors"
          style={{ ...LORA, borderRadius: "2px" }}
          rows={3}
          value={result.resume || ""}
          onChange={(e) => setField("resume", e.target.value)}
          data-testid="editor-resume"
        />
      </div>
      <div>
        <FieldLabel>Point fort</FieldLabel>
        <textarea
          className="w-full border border-[#DCD4C6] bg-white px-3 py-2 text-sm text-[#2B2623] resize-none focus:outline-none focus:border-[#C17F59] transition-colors"
          style={{ ...LORA, borderRadius: "2px" }}
          rows={2}
          value={result.point_fort || ""}
          onChange={(e) => setField("point_fort", e.target.value)}
          data-testid="editor-point-fort"
        />
      </div>
    </div>
  );
}
